import { Cards } from "../FlipCards/Cards";
import "./ServiceCard.css"
import ReactCardFlip from 'react-card-flip';
import { useReducer } from "react";
import { CardsBack } from "../FlipCards/CardsBack";
import { MdDirectionsBike } from 'react-icons/md';
import { GoTools } from 'react-icons/go';
import { FiTool } from 'react-icons/fi';
import { FaToolbox } from "react-icons/fa";
import { imageBIKE } from "./image";

const ServiceCards = () => {

  function reduce(state,action){
    switch (action.type) {
      case "Individual":
        return{...state,cardflipped1:!state.cardflipped1}
      case "Standard":
        return{...state,cardflipped2:!state.cardflipped2}
      case "Advanced":
        return{...state,cardflipped3:!state.cardflipped3}
      case "Full Service":
        return{...state,cardflipped4:!state.cardflipped4}
      default:
        break;
    }
  }

  let [state,dispatch] = useReducer(reduce,{
    cardflipped1:false,
    cardflipped2:false,
    cardflipped3:false,
    cardflipped4:false,

  })

  return ( 
    <div className="serviceCards">

      
      <section className="serviceCards__left">




      <ReactCardFlip behavior="click"
       isFlipped={state.cardflipped1}
       flipDirection="vertical"
        >
        <Cards
          icon={<FiTool/>}
          service={"Individual"}
          moreinfo={"find out more"}
          dispatch={dispatch}
        />
        <CardsBack 
          service={"Individual"}
          moreinfo={"find out more"}
          Description={"Your minimum needs with individual prices for individual people"}
          dispatch={dispatch}
          linkToService={""}
          />
      </ReactCardFlip>



      <ReactCardFlip behavior="click"
       isFlipped={state.cardflipped2}
       flipDirection="vertical"
       >
        <Cards
          icon={<GoTools/>}
          service={"Standard"}
          moreinfo={"find out more"}
          dispatch={dispatch}/>

        <CardsBack 
          service={"Standard"}
          moreinfo={"find out more"}
          dispatch={dispatch}
          Description={"Standared requirements, for a not so standared bike"}
          linkToService={"/StandardService"}
          />
          
      </ReactCardFlip>



      <ReactCardFlip behavior="click"
        flipDirection="vertical"
        isFlipped={state.cardflipped3}
      >
        <Cards
          icon={<FaToolbox/>}
          service={"Advanced"}
          moreinfo={"find out more"}
          dispatch={dispatch}
        />
        <CardsBack
          service={"Advanced"}
          moreinfo={"find out more"}
          dispatch={dispatch}
          Description={"There is nothing standered about these fix's so make a booking"}
          linkToService={"/AdvancedService"}
          />
      </ReactCardFlip>



      <ReactCardFlip behavior="click"
      flipDirection="vertical"
       isFlipped={state.cardflipped4}
       >
        <Cards
          icon={<MdDirectionsBike className=""/>}
          service={"Full Service"}
          moreinfo={"find out more"}
          dispatch={dispatch}
        />
        <CardsBack
          service={"Full Service"}
          moreinfo={"find out more"}
          dispatch={dispatch}
          Description={"Bike in need of a full service?. I do cheap fix's for an outstanding bike"}
          linkToService={"/FullService"}
          />
      </ReactCardFlip>



      

      </section>

      <section className="serviceCards__right">

        <div className="serviceCardInfo">

        {imageBIKE}


        </div>


      </section>

    </div>
   );
}
 
export default ServiceCards;